import { useToast } from 'vue-toastification';
import router from '@/router';
import { useAuthStore } from '@/stores/auth';
import Cookies from 'js-cookie';

const toast = useToast();

export const fetchWrapper = {
  get: request('GET'),
  post: request('POST'),
  put: request('PUT'),
  delete: request('DELETE'),
};

function request(method) {
  return async (url, body, withFiles) => {
    const authStore = useAuthStore();
    const token = authStore.getToken();
    
    const requestOptions = {
      method,
      credentials: 'include',
      headers: {},
    };
    
    // Adicionar token se disponível
    if (token) {
      requestOptions.headers['Authorization'] = `Bearer ${token}`;
    }
    
    if (body) {
      if (!withFiles) requestOptions.headers['Content-Type'] = 'application/json';
      requestOptions.body = !withFiles ? JSON.stringify(body) : body;
    }

    /*console.log('FetchWrapper: Fazendo requisição:', {
      url,
      method,
      headers: requestOptions.headers,
      body: body
    });*/

    return fetch(url, requestOptions).then(handleResponse);
  };
}

function handleResponse(response) {
  const authStore = useAuthStore();

  return response.text().then(async (text) => {
    /*console.log('FetchWrapper: Resposta recebida:', {
      status: response.status,
      statusText: response.statusText,
      text: text
    });*/
    
    const data = text && JSON.parse(text.toString());

    if (!response.ok) {
      if ([401, 403].includes(response.status) && data?.redirectPath) {
        await router.push(data.redirectPath);
      }
      let messages = null;
      if (data?.messages) messages = Object.values(data.messages).join('\n');

      let msg = messages || data?.message || data?.error || response.statusText;

      if (msg === 'Unauthorized') {
        msg = 'Acesso Negado';
      }

      if (data.forceLogout || data.logoutByLoa) {
        toast.error(msg.toString());
        authStore.logoutCallback();
        setTimeout(async () => {
          await router.push('/');
        }, 3000);
      } else {
        // Criar erro estruturado para capturar dados da API SIPE
        const error = new Error(msg.toString());
        error.response = {
          status: response.status,
          data: data
        };
        // Preservar a mensagem original da API SIPE
        error.originalMessage = data?.message || data?.mensagem || data?.error;
        throw error;
      }
    }

    return data;
  });
}
